import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Subheader (props) {

    const format = props.format
    const heatmap = props.heatmap
    const updateHeatmap = props.updateHeatmap
    
    useEffect(()=> {
        const position = document.getElementById('heatmap_btn').getBoundingClientRect().x
        d3.select('#h_sub').style('left', position + 'px')
    
        d3.select('#h_sub').selectAll('.h_heatmap').data(heatmap).join(
          function (enter) {
            const container = enter.append('div').attr('class', 'h_heatmap')

            const div = container.append('div')
            
            div.append('p')
              .attr('class', 'h_heatmap_longname')
              .html(d => format.longname(d.longname, d.code))
            
            div.append('p')
              .attr('class', 'h_heatmap_name')
              .html(d => format.name(d.code))
            
            container.append('p')
              .attr('class', 'h_heatmap_remove')
              .html('×')
              .on('click', (e,d) => updateHeatmap(d.code))
          },
          function (update) {
            update.select('.h_heatmap_longname').html(d => format.longname(d.longname, d.code))
            update.select('.h_heatmap_name').html(d => format.name(d.code))
            update.select('.h_heatmap_remove').on('click', (e,d) => updateHeatmap(d.code))
          }
        )
    })


    return (
        <div id='h_sub'>
          <h5 id="h_sub_title">Heatmap columns</h5>
        </div>
    )
}

export default Subheader;